// extracted by mini-css-extract-plugin
module.exports = {"offlineModal":"OfflineModal_offlineModal__3-dxE","content":"OfflineModal_content__3z90r","box":"OfflineModal_box__1SS2M"};